module.exports = __webpack_public_path__ + "static/media/167859_1778298343970_354762_n.a93310e9.jpg";